// tenx-labs page bundle -> dist/js/pages/tenx-labs.min.js
//
// Plain-ES port of the tenx-labs interactions, hero updated to the 2026-08
// offline redesign ("TenX Labs Offline.html"): the S-curve sits beside the H1
// and the per-stage detail is a card (data-dbox) under the hero grid instead
// of a panel stack. Behaviour ported from the design's logic class:
//   - default stage index 2 ("Capability Chasm"), detail card OPEN on load;
//   - peekDetail(): the card auto-closes 5s after load unless the visitor has
//     already interacted, so the whole curve is readable;
//   - ANY stage pick (curve dot, rail tick, drag, stepper, arrow keys)
//     re-opens the card on that stage; data-dclose / the data-dtoggle chip
//     toggle it by hand;
//   - apply() reconciles marker/drop/handle/nodes/ticks/curve emphasis and
//     the detail card (panel switching, border accent, num/name/Today tag).
//
// The S-curve is DOM/SVG (viewBox="0 0 1000 500" scaled by
// preserveAspectRatio=none + percentage-positioned nodes), NOT a canvas. The
// isNarrow (<900px) branch — rail labels hidden + a prev/next stepper — is
// reconciled at runtime like before. Tracking (dataLayer) is not ported.
//
// Also ported: the leadership profile drawer (reading #pe-tenx-people), the
// clientele marquee hover-pause, and the insights card hover. Shared nav
// interactions live in chrome.js.

(function () {
  "use strict";

  var root = document.querySelector(".pe-tenx");
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var NAMES = ["AI-aware", "AI-tooled", "Capability Chasm", "AI-capable", "Into the Process Estate", "Every Process Covered", "AI-native"];
  var DISPLAY = ["AI-aware", "AI-tooled", "The capability chasm", "AI-capable", "Into the process estate", "Every process covered", "AI-native"];
  var TODAY_FLAG = true;
  var CHASM_EMPHASIS = 1;
  var PEEK_MS = 5000; // detail card auto-close after load (design used 3s; product asked for 5)

  /* ============================ hero S-curve ============================= */
  var hero = $("#tenx-hero", root);
  var chart = hero && $("[data-chart]", hero);
  var i = 2; // render default stage (Capability Chasm) — "most enterprises today"; matches the SSR baseline
  var det = true; // detail card open? SSR ships it open on the default stage
  var drag = null, nudged = false, userMoved = false, xsCache = null;

  function nodes() { return hero ? $$("[data-node]", hero) : []; }
  function xs() {
    if (!xsCache || !xsCache.length) xsCache = nodes().map(function (n) { return parseFloat(n.getAttribute("data-x")); });
    return xsCache;
  }
  function nearest(pct) {
    var best = 0, d = Infinity;
    xs().forEach(function (x, k) { var dd = Math.abs(x - pct); if (dd < d) { d = dd; best = k; } });
    return best;
  }

  // The mobile prev/next stepper the design conditionally renders under the
  // rail when narrow (<900px). SSR omits it (desktop); create/remove it here.
  function stepperHtml() {
    return '<div data-stepper="1" style="margin-top: 12px; display: flex; align-items: center; justify-content: space-between; gap: 12px; border-top: 1px solid rgba(255, 255, 255, 0.14); padding-top: 10px;">'
      + '<button data-step="-1" aria-label="Previous position" style="all: unset; cursor: pointer; width: 46px; height: 46px; display: flex; align-items: center; justify-content: center; color: rgb(127, 211, 216); font-size: 19px;">←</button>'
      + '<span style="display: flex; flex-direction: column; align-items: center; gap: 4px; text-align: center;">'
      + '<span data-step-num="1" style="font-family: \'IBM Plex Mono\', monospace; font-size: 10.5px; letter-spacing: 0.18em; color: rgba(255, 255, 255, 0.5);">03 / 07</span>'
      + '<span data-step-name="1" style="font-size: 17px; font-weight: 500; letter-spacing: -0.012em; color: rgb(255, 255, 255);">The capability chasm</span>'
      + '</span>'
      + '<button data-step="1" aria-label="Next position" style="all: unset; cursor: pointer; width: 46px; height: 46px; display: flex; align-items: center; justify-content: center; color: rgb(127, 211, 216); font-size: 19px;">→</button>'
      + '</div>';
  }
  function bindStep(stepper) {
    $$("[data-step]", stepper).forEach(function (b) {
      b.addEventListener("click", function () {
        setStage(i + (parseInt(b.getAttribute("data-step"), 10) || 0), true);
      });
    });
  }
  function syncStepText(stepper) {
    var num = $("[data-step-num]", stepper); if (num) num.textContent = ("0" + (i + 1)) + " / 07";
    var name = $("[data-step-name]", stepper); if (name) name.textContent = DISPLAY[i];
  }

  // Reconcile the width-driven bits (isNarrow at 900px): rail labels + stepper.
  function syncWidth() {
    if (!hero) return;
    var narrow = window.innerWidth < 900;

    // rail stage labels
    $$("[data-label]", hero).forEach(function (l) { l.style.display = narrow ? "none" : "block"; });

    // mobile stepper (create/remove to mirror the design's conditional render)
    var rail = $("[data-rail]", hero);
    var stepper = $("[data-stepper]", hero);
    if (narrow && !stepper && rail && rail.parentNode) {
      rail.insertAdjacentHTML("afterend", stepperHtml());
      stepper = $("[data-stepper]", hero);
      bindStep(stepper);
    } else if (!narrow && stepper) {
      stepper.parentNode.removeChild(stepper);
      stepper = null;
    }
    if (stepper) syncStepText(stepper);
  }

  // Full render for a stage/detail change, ported from the design's apply().
  function apply(animate) {
    if (!hero) return;
    var ns = nodes();
    var active = ns[i];
    if (!active) return;
    var chasm = i === 2;
    var native = i === ns.length - 1;
    var accent = chasm ? "#F2673A" : "#2CC0C8";
    var x = parseFloat(active.getAttribute("data-x"));
    var y = parseFloat(active.getAttribute("data-y"));

    var marker = $("[data-marker]", hero);
    if (marker) {
      marker.style.left = x + "%";
      marker.style.top = y + "%";
      var dot = $("[data-dot]", marker); if (dot) dot.style.background = accent;
      var halo = $("[data-halo]", marker); if (halo) halo.style.background = accent;
    }
    var drop = $("[data-drop]", hero);
    if (drop) {
      drop.style.left = x + "%";
      drop.style.top = y + "%";
      drop.style.height = (100 - y) + "%";
      drop.style.background = chasm
        ? "linear-gradient(180deg,rgba(242,103,58,.75),rgba(242,103,58,0))"
        : "linear-gradient(180deg,rgba(44,192,200,.6),rgba(44,192,200,0))";
    }
    var handle = $("[data-handle]", hero);
    if (handle && !(drag && drag.live)) handle.style.left = x + "%";
    if (handle) handle.style.background = accent;

    ns.forEach(function (n, k) {
      var last = k === ns.length - 1;
      var on = k === i;
      var past = k < i;
      var v = $("[data-dotv]", n);
      if (!v) return;
      v.style.transform = on ? "scale(1.85)" : "scale(1)";
      if (k === 2) {
        v.style.borderColor = on ? "#F2673A" : "rgba(242,103,58,.62)";
        v.style.background = on ? "transparent" : "#14343A";
        var ring = $("[data-chasm-ring]", n); if (ring) ring.style.opacity = on ? "1" : "0";
      } else {
        v.style.borderColor = on ? "#2CC0C8" : (past ? "rgba(127,211,216,.6)" : "rgba(255,255,255,.3)");
        v.style.background = on ? "transparent" : (past ? "rgba(127,211,216,.5)" : "#14343A");
      }
      if (last) v.style.boxShadow = on ? "0 0 0 4px rgba(44,192,200,.16)" : "0 0 0 4px rgba(44,192,200,.1)";
      // the NEXT stage's dot pulses, inviting the click
      var isNext = k === i + 1;
      v.style.animation = isNext && !reduced ? "peNextDot 2.2s ease-in-out infinite" : "none";
      if (isNext) v.style.borderColor = k === 2 ? "rgba(242,103,58,.85)" : "rgba(127,211,216,.8)";
    });

    var narrow = window.innerWidth < 900;
    $$("[data-tick]", hero).forEach(function (t) {
      var k = parseInt(t.getAttribute("data-tick"), 10);
      var on = k === i;
      var mark = $("[data-mark]", t);
      var label = $("[data-label]", t);
      var col = k === 2 ? "#F2673A" : "#fff";
      if (mark) {
        mark.style.height = on ? "17px" : "8px";
        mark.style.background = on ? col : (k === 2 ? "rgba(242,103,58,.6)" : "rgba(255,255,255,.26)");
      }
      if (label) {
        label.style.display = narrow ? "none" : "block";
        label.style.color = on ? "#fff" : (k === 2 ? "rgba(242,103,58,.82)" : "rgba(255,255,255,.38)");
        label.style.fontWeight = on ? "600" : "400";
      }
    });

    var em = Math.max(0.4, Math.min(1.6, CHASM_EMPHASIS));
    var band = $("[data-band]", hero); if (band) band.setAttribute("opacity", ((chasm ? 1.25 : 0.6) * em).toFixed(3));
    $$("[data-edge]", hero).forEach(function (p) { p.style.stroke = "rgba(242,103,58," + ((chasm ? 0.72 : 0.34) * em).toFixed(3) + ")"; });
    var clabel = $("[data-chasm-label]", hero); if (clabel) clabel.style.color = chasm ? "#F2673A" : "rgba(242,103,58,.82)";
    var ghost = $("[data-ghost]", hero); if (ghost) ghost.style.stroke = "rgba(255,255,255," + (i <= 2 ? 0.32 : 0.14) + ")";
    var lower = $("[data-lower]", hero); if (lower) lower.style.stroke = "rgba(127,211,216," + (i <= 1 ? 0.9 : 0.5) + ")";
    var upper = $("[data-upper]", hero); if (upper) upper.style.stroke = i >= 3 ? "#2CC0C8" : "rgba(44,192,200,.62)";
    var mid = $("[data-mid]", hero); if (mid) mid.style.strokeWidth = chasm ? "5.2" : "4.4";
    var glow = $("[data-glow]", hero); if (glow) glow.style.strokeOpacity = chasm ? "0.34" : "0.18";

    var today = $("[data-today]", hero); if (today) today.style.opacity = TODAY_FLAG === false ? "0" : "1";
    var rail = $("[data-rail]", hero);
    if (rail) { rail.setAttribute("aria-valuenow", String(i + 1)); rail.setAttribute("aria-valuetext", NAMES[i]); }
    var num = $("[data-step-num]", hero); if (num) num.textContent = ("0" + (i + 1)) + " / 07";
    var name = $("[data-step-name]", hero); if (name) name.textContent = DISPLAY[i];

    // detail card: open/closed, accent border, active dpanel, chip + header text
    var wrap = $("[data-detailwrap]", hero);
    if (wrap) {
      var open = det !== false;
      var box = $("[data-dbox]", wrap);
      var chip = $("[data-dtoggle]", wrap);
      if (box) {
        var was = box.style.display;
        box.style.display = open ? "block" : "none";
        box.style.borderTopColor = chasm ? "#F2673A" : (native ? "#7FD3D8" : "#2CC0C8");
        $$("[data-dpanel]", box).forEach(function (p) {
          p.style.display = (parseInt(p.getAttribute("data-dpanel"), 10) === i) ? "block" : "none";
        });
        if (open && !reduced && (was === "none" || animate)) {
          box.style.animation = "none";
          void box.offsetWidth;
          box.style.animation = "peRise .42s cubic-bezier(.2,.7,.3,1) both";
        }
      }
      if (chip) {
        chip.style.display = open ? "none" : "inline-flex";
        chip.setAttribute("aria-expanded", open ? "true" : "false");
        var cn = $("[data-dchip]", chip); if (cn) cn.textContent = DISPLAY[i];
      }
      var dnum = $("[data-dnum]", wrap);
      if (dnum) { dnum.textContent = "0" + (i + 1) + " / 07"; dnum.style.color = chasm ? "#F2673A" : "#7FD3D8"; }
      var dname = $("[data-dname]", wrap); if (dname) dname.textContent = DISPLAY[i];
      var dtag = $("[data-dtag]", wrap);
      if (dtag) {
        dtag.style.display = (i === 1 || i === 6) ? "inline" : "none";
        dtag.textContent = i === 6 ? "The destination" : "Most enterprises today";
        dtag.style.color = i === 6 ? "#7FD3D8" : "#F2673A";
      }
    }
  }

  function stopNudge() {
    if (nudged) return;
    nudged = true;
    var h = $("[data-handle]", hero); if (h) h.style.animation = "none";
    var arrows = $("[data-cuearrows]", hero); if (arrows) arrows.style.opacity = "0";
  }
  function setStage(next, user, animate) {
    next = Math.max(0, Math.min(NAMES.length - 1, next));
    if (user) { userMoved = true; stopNudge(); det = true; } // any pick re-opens the detail card
    if (next === i) { apply(animate !== false); return; }
    i = next;
    apply(animate !== false);
  }
  function toggleDetail() {
    userMoved = true;
    stopNudge();
    det = det === false;
    apply(true);
  }

  // Replays the capability-chasm intro (QA: it used to play only once on load).
  // Resets to the chasm stage with the detail card open, re-runs the peRise
  // entrance on the headline + chart, re-arms the drag-nudge cue on the handle,
  // and restarts the ~5s peek auto-close. Driven by an IntersectionObserver that
  // fires on each fresh entry, so scrolling the hero back into view plays it again.
  var peekT = null;
  function playHeroChasm() {
    if (!hero) return;
    userMoved = false;
    nudged = false;
    i = 2;      // Capability Chasm
    det = true; // detail card open, as on first load
    var h1El = hero.querySelector("h1");
    if (h1El) { h1El.style.animation = "none"; void h1El.offsetWidth; h1El.style.animation = "peRise .9s cubic-bezier(.2,.7,.3,1) .1s both"; }
    if (chart) { chart.style.animation = "none"; void chart.offsetWidth; chart.style.animation = "peRise 1s cubic-bezier(.2,.7,.3,1) .24s both"; }
    var h = $("[data-handle]", hero);
    if (h && !reduced) { h.style.animation = "none"; void h.offsetWidth; h.style.animation = "peNudge 2.4s ease-in-out 1.6s 3 both"; }
    var arrows = $("[data-cuearrows]", hero); if (arrows) arrows.style.opacity = "1";
    apply(true);
    window.clearTimeout(peekT);
    peekT = window.setTimeout(function () {
      if (userMoved) return;
      det = false;
      apply(true);
    }, PEEK_MS);
  }

  function bindDrag() {
    if (!chart) return;
    var rail = $("[data-rail]", hero);
    if (!rail || chart.__bound) return;
    var pctOf = function (e) {
      var r = rail.getBoundingClientRect();
      return Math.max(0, Math.min(100, ((e.clientX - r.left) / Math.max(1, r.width)) * 100));
    };
    chart.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, live: false };
      userMoved = true; stopNudge();
      rail.style.cursor = "grabbing";
    });
    window.addEventListener("pointermove", function (e) {
      if (!drag || drag.id !== e.pointerId) return;
      if (!drag.live) {
        var dx = Math.abs(e.clientX - drag.x0), dy = Math.abs(e.clientY - drag.y0);
        if (dx < 5 || dx < dy) return;
        drag.live = true;
        var h = $("[data-handle]", hero); if (h) h.style.transition = "none";
      }
      if (e.cancelable) e.preventDefault();
      var pct = pctOf(e);
      var h2 = $("[data-handle]", hero); if (h2) h2.style.left = pct + "%";
      setStage(nearest(pct), true, false);
    }, { passive: false });
    var up = function (e) {
      if (!drag || drag.id !== e.pointerId) return;
      drag = null;
      rail.style.cursor = "grab";
      var h = $("[data-handle]", hero); if (h) h.style.transition = "left .72s cubic-bezier(.22,.61,.36,1),box-shadow .3s ease";
      apply();
    };
    window.addEventListener("pointerup", up);
    window.addEventListener("pointercancel", up);
    chart.__bound = true;
  }

  if (hero) {
    // curve dots jump to a stage (and re-open the detail card)
    nodes().forEach(function (n) {
      n.addEventListener("click", function () { setStage(parseInt(n.getAttribute("data-node"), 10) || 0, true); });
    });
    // ticks jump to a stage
    $$("[data-tick]", hero).forEach(function (t) {
      t.addEventListener("click", function () { setStage(parseInt(t.getAttribute("data-tick"), 10) || 0, true); });
    });
    // detail card open/close (× in the card header, the chip while closed)
    var dtoggleEl = $("[data-dtoggle]", hero); if (dtoggleEl) dtoggleEl.addEventListener("click", toggleDetail);
    var dcloseEl = $("[data-dclose]", hero); if (dcloseEl) dcloseEl.addEventListener("click", toggleDetail);
    // arrow-key stepping on the rail (+ Home/End)
    var railEl = $("[data-rail]", hero);
    if (railEl) {
      railEl.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft" || e.key === "ArrowDown") { e.preventDefault(); setStage(i - 1, true); }
        else if (e.key === "ArrowRight" || e.key === "ArrowUp") { e.preventDefault(); setStage(i + 1, true); }
        else if (e.key === "Home") { e.preventDefault(); setStage(0, true); }
        else if (e.key === "End") { e.preventDefault(); setStage(NAMES.length - 1, true); }
      });
    }
    bindDrag();
    syncWidth();
    // Reconcile the SSR resting state (the markup ships neutral SVG emphasis;
    // this settles it onto the chasm default).
    apply(false);
    // Replay the chasm intro on every entry into view (see playHeroChasm). The
    // first intersection on load plays it too; scrolling away + back replays it.
    if (!reduced && "IntersectionObserver" in window) {
      var heroWasIn = false;
      var heroObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !heroWasIn) { heroWasIn = true; playHeroChasm(); }
          else if (!e.isIntersecting) { heroWasIn = false; }
        });
      }, { threshold: 0.35 });
      heroObs.observe(chart || hero);
    } else {
      // reduced motion / no observer: settle open on the chasm, no scripted replay
      window.setTimeout(function () {
        if (userMoved) return;
        det = false;
        apply(true);
      }, PEEK_MS);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncWidth);
    window.setTimeout(syncWidth, 400);
  }

  /* ============================ worked-example switcher (section 02) ===== */
  // "This is what an AI-capable organisation looks like." — clicking one of the
  // 3 data-wrow buttons switches the paired SVG diagram on the right (ported
  // verbatim from the redesign's setWorkStage/renderWork). Three stages match
  // the three rows:
  //   0 "see"    — hotspots on THE WORK lit coral, underlines shown.
  //   1 "judge"  — ASSIST/AGENT/AUTOMATE diamonds + links to the (now teal)
  //                tasks, warning icons + return paths flowing to the owner,
  //                whose glyph is haloed coral.
  //   2 "limits" — dashed teal "AI OPERATES WITHIN SET LIMITS" zone around the
  //                work + the coral "HUMAN OVERSIGHT STAYS HERE" boundary line.
  // Every overlay lives in the SVG at opacity 0; renderWork toggles opacity +
  // colours. measureWork scales the mono labels and verdict/output marks up so
  // they stay legible when the diagram renders small. renderWork(0) runs on
  // mount (not just on click), so the diagram settles into "see" on load.
  var capSection = $("#tenx-capability", root);
  var workStage = capSection && $("[data-wgrid]", capSection);
  var wi = 0;
  var wboost = 1;

  // measured on mount and resize only — keeps glyphs and mono labels legible
  // when the diagram renders small
  function measureWork() {
    if (!workStage) return;
    var svg = $("svg[viewBox]", workStage);
    if (!svg) return;
    var b = svg.getBoundingClientRect();
    var sc = Math.min(b.width / 1000, b.height / 520);
    if (!(sc > 0.05)) return;
    // On a phone the diagram is width-bound and renders small. The old formula
    // inflated the mono labels/glyphs hard (11/sc, 0.66/sc) to keep them legible,
    // but that made them collide and clutter. Cap the inflation so the whole
    // diagram fits the viewport with no scroll and nothing overlaps — the labels
    // grow only to a bounded size (FMAX viewBox units) instead of unbounded.
    var FMAX = 15;
    var infl = function (base) { return Math.min(FMAX, Math.max(base, 11 / sc)); };
    wboost = Math.min(1.22, Math.max(1, 0.66 / sc));
    $$("text[data-fs]", workStage).forEach(function (t) {
      var base = parseFloat(t.getAttribute("data-fs")) || 12;
      t.setAttribute("font-size", infl(base).toFixed(1));
    });
    $$("[data-wverd],[data-wout]", workStage).forEach(function (el) {
      el.style.transformBox = "fill-box";
      el.style.transformOrigin = "center";
      el.style.transform = "scale(" + wboost.toFixed(3) + ")";
    });
    // The boosted label and the (also boosted) person glyphs both grow toward
    // each other at the bottom edge, so "THE PEOPLE WHO OWN IT" sits inside the
    // figures on narrow renders. Drop the label below the scaled glyphs and
    // give the viewBox the extra bottom room; at desktop scale the computed y
    // stays under 454 and the viewBox stays 462, so nothing moves.
    var ownlab = $("[data-wownlab]", workStage);
    if (ownlab && wboost > 1.05) {
      var ofs = infl(parseFloat(ownlab.getAttribute("data-fs")) || 12);
      var glyphBottom = 410.5 + 14.5 * wboost; // persons: 29u tall, centered at y 410.5
      var oy = Math.max(454, glyphBottom + 26 + 0.72 * ofs);
      ownlab.setAttribute("y", oy.toFixed(1));
      var vh = Math.max(462, oy + 0.3 * ofs + 6 - 14);
      svg.setAttribute("viewBox", "0 14 1000 " + vh.toFixed(0));
    } else if (ownlab) {
      ownlab.setAttribute("y", "454");
      svg.setAttribute("viewBox", "0 14 1000 462");
    }
  }

  function renderWork(idx) {
    if (!workStage) return;
    var rows = $$("[data-wrow]", workStage);
    rows.forEach(function (row, k) {
      var on = k === idx;
      var node = $("[data-wnode]", row);
      var num = $("[data-wnum]", row);
      var title = $("[data-wtitle]", row);
      var note = $("[data-wnote]", row);
      if (node) {
        node.style.background = on ? "#F2673A" : "#fff";
        node.style.borderColor = on ? "#F2673A" : "rgba(20,24,26,.24)";
        node.style.transform = on ? "scale(1.3)" : "scale(1)";
      }
      if (num) num.style.color = on ? "#F2673A" : "rgba(20,24,26,.34)";
      if (title) title.style.color = on ? "#14181A" : "rgba(20,24,26,.42)";
      if (note) {
        note.style.display = on ? "block" : "none";
        note.style.opacity = on ? "1" : "0";
      }
      row.setAttribute("aria-expanded", on ? "true" : "false");
    });

    var see = idx === 0, judge = idx === 1, limits = idx === 2;
    function at(k, past) { return idx === k ? 1 : (idx > k ? (past == null ? 0.24 : past) : 0); }
    function setOp(list, val) { list.forEach(function (el) { el.style.opacity = String(val); }); }

    $$("[data-wtask]", workStage).forEach(function (t) {
      var hot = t.getAttribute("data-hot") === "1";
      if (hot) {
        t.style.stroke = see ? "#F2673A" : "#2CC0C8";
        t.style.strokeWidth = see ? "1.7" : "1.4";
        t.style.strokeOpacity = see ? "1" : "0.8";
        t.style.fill = see ? "rgba(242,103,58,.12)" : "rgba(44,192,200,.09)";
      } else {
        t.style.stroke = "rgba(20,24,26,.18)";
        t.style.fill = "rgba(20,24,26,.025)";
      }
    });

    setOp($$("[data-wunder]", workStage), at(0, 0.3));
    var links = $$("[data-wlink]", workStage);
    setOp(links, idx >= 1 ? (judge ? 0.8 : 0.4) : 0);
    setOp($$("[data-wdia]", workStage), idx >= 1 ? (judge ? 0.85 : 0.5) : 0);
    setOp($$("[data-wdlab]", workStage), idx >= 1 ? 0.85 : 0);
    var rets = $$("[data-wret]", workStage);
    setOp(rets, at(1));
    setOp($$("[data-wout]", workStage), at(1, 0.2));
    setOp($$("[data-wverd]", workStage), at(1));
    links.forEach(function (l) { l.style.strokeWidth = judge ? "1.6" : "1.2"; });
    rets.forEach(function (l) { l.style.strokeWidth = judge ? "1.7" : "1.1"; });

    var halo = $("[data-whalo]", workStage);
    if (halo) halo.style.opacity = judge ? "0.12" : "0";
    var zone = $("[data-wzone]", workStage);
    if (zone) { zone.style.opacity = String(at(2, 0.16)); zone.style.strokeWidth = limits ? "1.5" : "1.1"; }
    var zlab = $("[data-wzlab]", workStage);
    if (zlab) zlab.style.opacity = String(at(2, 0.22));
    $$("[data-wover]", workStage).forEach(function (o) { o.style.opacity = String(at(2, 0.22)); o.style.strokeWidth = limits ? "1.5" : "1.1"; });
    var ownlab = $("[data-wownlab]", workStage);
    if (ownlab) ownlab.style.opacity = limits ? "0.18" : "1";

    $$("[data-wperson]", workStage).forEach(function (g) {
      var isJudge = g.getAttribute("data-judge") === "1";
      g.style.transform = "scale(" + (wboost * (isJudge && judge ? 1.5 : 1)).toFixed(3) + ")";
      g.style.color = isJudge && judge ? "#F2673A" : "rgba(20,24,26,.45)";
    });
  }

  function setWorkStage(idx) {
    idx = Math.max(0, Math.min(2, idx));
    if (wi === idx) return;
    wi = idx;
    var list = $("[data-wlist]", workStage);
    if (list) list.removeAttribute("data-widle");
    renderWork(idx);
  }

  if (workStage) {
    $$("[data-wrow]", workStage).forEach(function (row) {
      row.addEventListener("click", function () {
        setWorkStage(parseInt(row.getAttribute("data-wrow"), 10) || 0);
      });
    });
    measureWork();
    renderWork(wi);
    window.addEventListener("resize", function () { measureWork(); renderWork(wi); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measureWork(); renderWork(wi); });
    window.setTimeout(function () { measureWork(); renderWork(wi); }, 400);
  }

  /* ============================ leadership drawer ======================== */
  var data = {};
  try { var rawEl = $("#pe-tenx-people"); if (rawEl) data = JSON.parse(rawEl.textContent || "{}"); } catch (e) { data = {}; }
  var lead = $("#tenx-leadership", root);
  var drawer = $("[data-drawer]", root), veil = $("[data-veil]", root);
  var drX = $("[data-dr-x]", root), drKind = $("[data-dr-kind]", root), drScroll = $("[data-dr-scroll]", root);
  var drImg = $("[data-dr-img]", root), drName = $("[data-dr-name]", root), drRole = $("[data-dr-role]", root);
  var drLi = $("[data-dr-li]", root), drBio = $("[data-dr-bio]", root);
  var drState = null, lastFocus = null, settleT = null, hoverKey = null;

  function leadHover(card, on) {
    var q = function (k) { return card.querySelector("[data-" + k + "]"); };
    card.style.background = on ? "#F2673A" : "#FFFFFF";
    var bar = q("bar"); if (bar) bar.style.transform = on ? "none" : "scaleX(0)";
    var shot = q("shot"); if (shot) shot.style.transform = on ? "scale(1.035)" : "none";
    var role = q("role"); if (role) role.style.color = on ? "rgba(20,24,26,.74)" : "rgba(8,27,28,.54)";
    var more = q("more"); if (more) more.style.color = on ? "#14181A" : "rgba(8,27,28,.52)";
    var plus = q("plus"); if (plus) plus.style.color = on ? "#14181A" : "#F2673A";
  }
  function applyDrawer(animate) {
    if (!drawer || !veil) return;
    var open = !!drState;
    drawer.style.transition = animate ? "transform .52s cubic-bezier(.4,0,.2,1)" : "none";
    veil.style.transition = animate ? "opacity .4s ease" : "none";
    drawer.style.transform = open ? "none" : "translateX(101%)";
    drawer.style.pointerEvents = open ? "auto" : "none";
    veil.style.opacity = open ? "1" : "0";
    veil.style.pointerEvents = open ? "auto" : "none";
    if (open) drawer.removeAttribute("inert"); else drawer.setAttribute("inert", "");
  }
  function fillDrawer(p) {
    if (drKind) drKind.textContent = p && p.kind ? p.kind : "Profile";
    if (drName) drName.textContent = p ? (p.name || "") : "";
    if (drRole) drRole.textContent = p ? (p.role || "") : "";
    if (drLi) drLi.href = p && p.li ? p.li : "#";
    if (drImg) drImg.style.backgroundImage = p && p.img ? 'url("' + p.img + '")' : "none";
    if (drBio) drBio.innerHTML = p && p.bio ? p.bio : "";
  }
  function settle() {
    window.clearTimeout(settleT);
    settleT = window.setTimeout(function () { applyDrawer(false); }, 580);
  }
  function openProfile(key, trigger) {
    if (!data[key]) return;
    lastFocus = trigger || null;
    drState = key;
    fillDrawer(data[key]);
    applyDrawer(true);
    document.body.style.overflow = "hidden";
    if (drScroll) drScroll.scrollTop = 0;
    if (drX) drX.focus();
    settle();
  }
  function closeProfile() {
    if (!drState) return;
    drState = null;
    applyDrawer(true);
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
    settle();
  }
  if (lead) {
    $$("[data-p]", lead).forEach(function (card) {
      card.addEventListener("mouseenter", function () { hoverKey = card.dataset.p; leadHover(card, true); });
      card.addEventListener("mouseleave", function () { if (hoverKey === card.dataset.p) hoverKey = null; leadHover(card, false); });
      card.addEventListener("focus", function () { hoverKey = card.dataset.p; leadHover(card, true); });
      card.addEventListener("blur", function () { if (hoverKey === card.dataset.p) hoverKey = null; leadHover(card, false); });
      card.addEventListener("click", function () { openProfile(card.dataset.p, card); });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openProfile(card.dataset.p, card); }
      });
    });
  }
  if (drX) drX.addEventListener("click", closeProfile);
  if (veil) veil.addEventListener("click", closeProfile);
  window.addEventListener("keydown", function (e) { if (e.key === "Escape" && drState) closeProfile(); });

  /* ============================ clientele marquee ======================== */
  var clients = $("#tenx-clientele", root);
  if (clients) {
    if (reduced) {
      $$("[data-marquee]", clients).forEach(function (t) { t.style.animation = "none"; });
      $$("[data-row]", clients).forEach(function (r) { r.style.overflowX = "auto"; });
    }
    $$("[data-row]", clients).forEach(function (row) {
      row.addEventListener("mouseenter", function () {
        var t = row.querySelector("[data-marquee]"); if (t) t.style.animationPlayState = "paused";
      });
      row.addEventListener("mouseleave", function () {
        var t = row.querySelector("[data-marquee]"); if (t) t.style.animationPlayState = "running";
      });
    });
  }

  /* ============================ insights card hover ===================== */
  var insights = $("#tenx-insights", root);
  function cardHover(el, on) {
    var img = el.querySelector("[data-ci]"); if (img) img.style.transform = on ? "scale(1.055)" : "scale(1)";
    var tint = el.querySelector("[data-ct]"); if (tint) tint.style.opacity = on ? "1" : "0";
    var arrow = el.querySelector("[data-ca]"); if (arrow) arrow.style.transform = on ? "translateX(7px)" : "translateX(0)";
  }
  if (insights) {
    $$("a", insights).forEach(function (el) {
      if (!el.querySelector("[data-ci]")) return;
      el.addEventListener("mouseenter", function () { cardHover(el, true); });
      el.addEventListener("mouseleave", function () { cardHover(el, false); });
    });
  }

  /* ============= AI Gym + Atlas: scripted iframe walkthroughs =========== */
  // The AI Gym and Atlas "demos" are the theme-bundled mini-apps
  // (assets/aigym/index.html, assets/atlas/index.html) embedded in a scaled,
  // pointer-events:none iframe and driven like a screencast: a fake cursor
  // points/clicks the app's own [data-f]/[data-s]/[data-nav] hooks, scrolls,
  // opens lesson players and runs the sim, with a progress bar + caption, on a
  // loop. Ported from the design's DCLogic driver (gymPlay / atlasPlay). Each
  // viewer is gated by an IntersectionObserver (runs only while on screen) and
  // is skipped entirely under prefers-reduced-motion — the app then just shows
  // its home screen, no motion.
  var wait = function (ms) { return new Promise(function (r) { window.setTimeout(r, ms); }); };
  function glide(win, to, ms) {
    var from = win.scrollY, d = to - from, t0 = performance.now();
    return new Promise(function (res) {
      requestAnimationFrame(function step(now) {
        var p = Math.min(1, (now - t0) / ms);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        win.scrollTo(0, from + d * e);
        if (p < 1) requestAnimationFrame(step); else res();
      });
    });
  }

  /* ---- AI Gym ---- */
  var gymWrap = $("[data-gym]", root), gymStage, gymFrame, gymCursor, gymCap, gymBar;
  var gk = 1, gt = 0, gseq = 0, gvis = false, gready = false, grun = false, gymOn = false;

  function gDoc() { return gymFrame && gymFrame.contentDocument; }
  function gWin() { return gymFrame && gymFrame.contentWindow; }
  function gEl(sel) { var d = gDoc(); return d ? d.querySelector(sel) : null; }
  function gCap(t) { if (gymCap && t) gymCap.textContent = t; }
  function sizeGym() {
    if (!gymStage || !gymFrame) return;
    var w = gymStage.clientWidth; if (!w) return;
    gk = w / 1440;
    gymFrame.style.transform = "scale(" + gk.toFixed(4) + ")";
    gymStage.style.height = Math.round(900 * gk) + "px";
  }
  function gRect(el) {
    var r = el.getBoundingClientRect();
    if (el.ownerDocument !== gDoc()) {
      var fr = gEl("#frame");
      if (fr) { var o = fr.getBoundingClientRect(); return { left: o.left + r.left, top: o.top + r.top, width: r.width, height: r.height }; }
    }
    return r;
  }
  function gFrameDoc() {
    var fr = gEl("#frame"), d = fr && fr.contentDocument;
    return d && d.body && d.body.childNodes.length ? d : null;
  }
  async function gWaitFor(fn, ms) {
    var t0 = Date.now();
    while (Date.now() - t0 < (ms || 4000)) { var v = fn(); if (v) return v; await wait(120); }
    return null;
  }
  function gCursorAt(r, scale) {
    if (!r || !gymCursor) return;
    if (!r.width && !r.height && !r.left && !r.top) return;
    var x = (r.left + r.width / 2) * gk, y = (r.top + Math.min(r.height / 2, 26)) * gk;
    gymCursor.style.opacity = "1";
    gymCursor.style.transform = "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px) scale(" + (scale || 1) + ")";
  }
  function gCursorTo(el, scale) { if (el) gCursorAt(gRect(el), scale); }
  async function gPoint(sel, hold) {
    var el = typeof sel === "string" ? gEl(sel) : sel;
    gCursorTo(el, 1);
    await wait(hold == null ? 680 : hold);
    return el;
  }
  async function gClick(sel) {
    var el = typeof sel === "string" ? gEl(sel) : sel;
    if (!el) return null;
    gCursorTo(el, 0.72);
    if (gymCursor) gymCursor.style.background = "rgba(232,104,58,.35)";
    await wait(190);
    var r = gRect(el); el.click();
    if (gymCursor) gymCursor.style.background = "rgba(23,114,111,.16)";
    gCursorAt(r, 1);
    await wait(240);
    return el;
  }
  function gScroll(to, ms) { var w = gWin(); return w ? glide(w, to, ms) : wait(0); }
  function gScrollTo(sel, ms, pad) {
    var el = gEl(sel), w = gWin();
    if (!el || !w) return wait(0);
    var y = el.getBoundingClientRect().top + w.scrollY - (pad == null ? 70 : pad);
    return gScroll(Math.max(0, y), ms || 900);
  }
  function gScrollInner(sel, ms, pad) {
    var d = gFrameDoc(); if (!d) return wait(0);
    var el = d.querySelector(sel), w = d.defaultView;
    if (!el || !w) return wait(0);
    var y = el.getBoundingClientRect().top + w.scrollY - (pad == null ? 60 : pad);
    return glide(w, Math.max(0, y), ms || 1100);
  }
  async function gHome() {
    var w = gWin();
    if (!w || !w.S) return;
    if (w.S.screen !== "home") {
      var back = gEl(".backhome");
      if (back) { await gClick(back); } else { w.S.screen = "home"; if (w.render) w.render(); }
    }
    if (w.scrollTo) w.scrollTo(0, 0);
    if (gymCursor) gymCursor.style.opacity = "0";
    await wait(420);
  }
  function gBar(ms) {
    if (!gymBar) return;
    gymBar.style.transition = "none"; gymBar.style.width = "0%";
    void gymBar.offsetWidth;
    gymBar.style.transition = "width " + ms + "ms linear"; gymBar.style.width = "100%";
  }
  function styleGymTabs(i) {
    if (!gymWrap) return;
    $$("[data-gtab]", gymWrap).forEach(function (b) {
      var on = parseInt(b.getAttribute("data-gtab"), 10) === i;
      b.style.color = on ? "#fff" : "rgba(255,255,255,.42)";
      b.style.borderColor = on ? "rgba(255,255,255,.4)" : "rgba(255,255,255,.14)";
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
  }
  async function gymPlay(t) {
    gt = t;
    styleGymTabs(t);
    var tok = ++gseq;
    grun = true;
    var alive = function () { return tok === gseq && gvis !== false && !!gDoc(); };
    var step = async function (ms, fn, cap) {
      if (!alive()) throw "stop";
      if (cap) gCap(cap);
      if (fn) await fn();
      if (!alive()) throw "stop";
      if (ms) await wait(ms);
      if (!alive()) throw "stop";
    };
    var dur = [13000, 14000, 14000, 14400][t] || 13500;
    try {
      gBar(dur);
      await gHome();
      if (t === 0) {
        await step(450, null, "Home · every function has its own process");
        await step(180, function () { return gPoint('[data-f="6"]', 520); }, "Open Leadership · AI as your Chief of Staff");
        await step(640, function () { return gClick('[data-f="6"]'); });
        await step(600, null, "Six moments in the week, mapped as stages");
        await step(700, function () { return gClick('[data-s="0"]'); }, "Stage 1 · Synthesis — walk in already briefed");
        await step(700, function () { return gClick('[data-s="1"]'); }, "Stage 2 · Decision support — the case argued both ways");
        await step(700, function () { return gClick('[data-s="2"]'); }, "Stage 3 · Communication — written in your own voice");
        await step(700, function () { return gClick('[data-s="3"]'); }, "Stage 4 · Early warning — what is slipping, before it turns red");
        await step(700, function () { return gClick('[data-s="4"]'); }, "Stage 5 · Sounding board — the argument rehearsed in private");
        await step(820, function () { return gClick('[data-s="5"]'); }, "Stage 6 · Sponsorship — AI proposals qualified and sponsored");
        await step(1500, function () { return gScrollTo(".panel", 850); }, "Each stage carries its own hotspots, lessons and prompt");
      } else if (t === 1) {
        await step(400, null, "Home · open Order to cash");
        await step(160, function () { return gPoint('[data-f="0"]', 520); });
        await step(600, function () { return gClick('[data-f="0"]'); }, "Order to cash · five stages, purchase order to ageing");
        await step(680, function () { return gClick('[data-s="0"]'); }, "Stage 1 · Order capture — orders read from every format");
        await step(680, function () { return gClick('[data-s="1"]'); }, "Stage 2 · Credit and billing — holds released, blocks cleared");
        await step(680, function () { return gClick('[data-s="2"]'); }, "Stage 3 · Collections — the ageing queue chased");
        await step(760, function () { return gClick('[data-s="3"]'); }, "Stage 4 · Cash application — three hotspots recorded");
        await step(600, function () { return gScrollTo(".panel", 800); }, "Scroll down to the AI hotspots at this stage");
        await step(1500, function () { return gScrollTo(".hs", 850, 90); }, "A hotspot is where AI changes how the work is done");
        await step(1900, function () { return gScrollTo(".hs + .hs", 900, 90); }, "Each one carries its lessons, its practice and its prompt");
      } else if (t === 2) {
        await step(320, null, "Home · open Procure to pay");
        await step(140, function () { return gPoint('[data-f="1"]', 420); });
        await step(520, function () { return gClick('[data-f="1"]'); }, "Procure to pay · six stages, requisition to reporting");
        await step(560, function () { return gClick('[data-s="0"]'); }, "Stage 1 · Requisition — requests read, categorised and gated");
        await step(420, function () { return gScrollTo(".panel", 750); }, "Scroll down to the hotspot recorded at this stage");
        await step(160, function () { return gPoint('.hs .open[data-k="file"]', 400); }, "Open lessons");
        await step(260, function () { return gClick('.hs .open[data-k="file"]'); });
        await step(400, function () { return gWaitFor(gFrameDoc, 5000); }, "The lesson opens on the case itself");
        await step(1500, function () { return gScrollInner(".les", 1000, 70); }, "Lesson 1 · how AI reads a free-text requisition");
        await step(1500, function () { return gScrollInner(".les + .les", 1000, 70); }, "Lesson 2 · how to instruct the gate, clause by clause");
        await step(1400, function () { return gScrollInner(".pblock", 900, 70); }, "The prompt · req-gate v1, and practice on the same case");
      } else {
        await step(300, null, "Home · open Order to cash");
        await step(160, function () { return gPoint('[data-f="0"]', 420); });
        await step(480, function () { return gClick('[data-f="0"]'); }, "Order to cash · Stage 1 · Order capture");
        await step(420, function () { return gClick('[data-s="0"]'); }, "Sales order entry · the hotspot in this stage");
        await step(380, function () { return gScrollTo(".panel", 700); }, "Scroll down to the lesson built on it");
        await step(180, function () { return gPoint('.hs .open[data-k="file"]', 380); }, "Open lessons");
        await step(260, function () { return gClick('.hs .open[data-k="file"]'); });
        await step(400, function () { return gWaitFor(gFrameDoc, 5000); }, "Two lessons, then the simulation");
        await step(450, function () { return gScrollInner("#sim", 1000, 60); }, "Scroll to the simulation · a scanned purchase order");
        var ld = gFrameDoc();
        if (ld) {
          var runBtn = ld.querySelector("#run");
          await step(140, function () { return gPoint(runBtn, 300); }, "Run the extraction on the sample order");
          await step(3600, function () { return gClick(runBtn); }, "Every field read is marked, with the line it came from");
          await step(700, null, "Two fields it could not read go to FLAGS, not to a guess");
          await step(900, function () { return gClick(ld.querySelector("#book")); }, "You check the extraction, then book the order");
        } else {
          await step(2600, null, "The simulation runs on the scanned order");
        }
      }
      await step(500, null);
      if (alive()) gymPlay(t);
    } catch (e) { grun = false; }
  }
  function mountGym() {
    if (!gymWrap || gymOn) return;
    gymOn = true;
    gymStage = $("[data-gstage]", gymWrap); gymFrame = $("[data-gframe]", gymWrap);
    gymCursor = $("[data-gcursor]", gymWrap); gymCap = $("[data-gcap]", gymWrap); gymBar = $("[data-gbar]", gymWrap);
    sizeGym();
    if (reduced) return; // no scripted motion; app shows its home screen
    gymFrame.addEventListener("load", function () { gready = true; if (gvis && !grun) gymPlay(gt); });
    var d = gDoc();
    if (d && d.readyState === "complete" && d.querySelector("[data-f]")) gready = true;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { gvis = e.isIntersecting; if (e.isIntersecting && gready && !grun) gymPlay(gt); });
    }, { threshold: 0.2 }).observe(gymWrap);
  }
  $$("[data-gtab]", gymWrap || document).forEach(function (b) {
    b.addEventListener("click", function () {
      if (reduced) { styleGymTabs(parseInt(b.getAttribute("data-gtab"), 10) || 0); return; }
      gymPlay(parseInt(b.getAttribute("data-gtab"), 10) || 0);
    });
  });

  /* ---- AI Governance · Atlas ---- */
  var govWrap = $("[data-gov]", root), atWrap, atStage, atFrame, atCursor, atCap, atBar;
  var ak = 1, aseq = 0, avis = false, aready = false, arun = false, atlasOn = false;

  function aDoc() { return atFrame && atFrame.contentDocument; }
  function aWin() { return atFrame && atFrame.contentWindow; }
  function aEl(sel) { var d = aDoc(); return d ? d.querySelector(sel) : null; }
  function aCap(t) { if (atCap && t) atCap.textContent = t; }
  function sizeAtlas() {
    if (!atStage || !atFrame) return;
    var w = atStage.clientWidth; if (!w) return;
    ak = w / 1440;
    atFrame.style.transform = "scale(" + ak.toFixed(4) + ")";
    atStage.style.height = Math.round(900 * ak) + "px";
  }
  function aCursorTo(el, scale) {
    if (!el || !atCursor) return;
    var r = el.getBoundingClientRect();
    atCursor.style.opacity = "1";
    atCursor.style.transform = "translate(" + ((r.left + r.width / 2) * ak).toFixed(1) + "px," +
      ((r.top + Math.min(r.height / 2, 22)) * ak).toFixed(1) + "px) scale(" + (scale || 1) + ")";
  }
  async function aPoint(sel, hold) {
    var el = typeof sel === "string" ? aEl(sel) : sel;
    aCursorTo(el, 1);
    await wait(hold == null ? 620 : hold);
    return el;
  }
  async function aClick(sel) {
    var el = typeof sel === "string" ? aEl(sel) : sel;
    if (!el) return null;
    aCursorTo(el, 1);
    await wait(300);
    aCursorTo(el, 0.7);
    if (atCursor) atCursor.style.background = "rgba(242,103,58,.34)";
    await wait(170);
    el.click();
    if (atCursor) atCursor.style.background = "rgba(23,114,111,.16)";
    aCursorTo(el, 1);
    await wait(220);
    return el;
  }
  function aScroll(to, ms) { var w = aWin(); return w ? glide(w, Math.max(0, to), ms) : wait(0); }
  function aScrollBy(dy, ms) { var w = aWin(); return w ? aScroll(w.scrollY + dy, ms || 1000) : wait(0); }
  function aScrollTo(sel, ms, pad) {
    var el = aEl(sel), w = aWin();
    if (!el || !w) return wait(0);
    var y = el.getBoundingClientRect().top + w.scrollY - (pad == null ? 96 : pad);
    return aScroll(y, ms || 1000);
  }
  function aScrollEnd(ms) { var d = aDoc(); return d ? aScroll(Math.max(0, d.body.scrollHeight - 900), ms || 1600) : wait(0); }
  function aBar(ms) {
    if (!atBar) return;
    atBar.style.transition = "none"; atBar.style.width = "0%";
    void atBar.offsetWidth;
    atBar.style.transition = "width " + ms + "ms linear"; atBar.style.width = "100%";
  }
  async function atlasPlay() {
    var tok = ++aseq;
    arun = true;
    var alive = function () { return tok === aseq && avis !== false && !!aDoc(); };
    var step = async function (ms, fn, cap) {
      if (!alive()) throw "stop";
      if (cap) aCap(cap);
      if (fn) await fn();
      if (!alive()) throw "stop";
      if (ms) await wait(ms);
      if (!alive()) throw "stop";
    };
    try {
      aBar(92000);
      var w = aWin();
      if (w && w.go) { w.go("overview"); } else { await aClick('[data-nav="overview"]'); }
      if (atCursor) atCursor.style.opacity = "0";
      await wait(500);
      await step(1300, null, "Governance overview · the whole AI estate on one screen");
      await step(900, function () { return aPoint('[data-screen="overview"] .kpi:nth-child(3)', 700); }, "Six items need attention before the next batch closes");
      await step(1700, function () { return aScrollTo('[data-anchor="dims"]', 1000); }, "Twelve dimensions, weighted by regulatory pressure and data exposure");
      await step(1500, function () { return aScrollBy(430, 1100); }, "Deferred dimensions stay on the record, never off the page");
      await step(1600, function () { return aScrollTo('[data-anchor="tasks"]', 950); }, "And what the 27 Jul cycle is waiting on, with owners");
      await step(1200, function () { return aClick('[data-nav="registry"]'); }, "Agent registry · every agent in scope, internal and vendor");
      await step(1700, function () { return aClick('[data-agent="case-setup"] .hd'); }, "Each agent opens into the use cases it was composed from");
      await step(1400, function () { return aScrollTo('[data-agent="data-integrity"]', 950); }, "Boundary and tier recorded per use case, not per tool");
      await step(2100, function () { return aScrollEnd(1800); }, "To the end of the register · the vendor platforms shipping agents into your contracts");
      await step(1100, function () { return aClick('[data-nav="obligations"]'); }, "Obligations · the regulatory surface the programme answers to");
      await step(1000, function () { return aClick('[data-ochips] [data-filter="federal"]'); }, "Federal · six frameworks, each mapped to controls");
      await step(1000, function () { return aClick('[data-ochips] [data-filter="state"]'); }, "State · four statutes, home state first");
      await step(1000, function () { return aClick('[data-ochips] [data-filter="force"]'); }, "In force · seven obligations live today");
      await step(1000, function () { return aClick('[data-ochips] [data-filter="watch"]'); }, "On watch · three arriving, dated");
      await step(900, function () { return aClick('[data-ochips] [data-filter="all"]'); }, "All ten, mapped to the controls that satisfy them");
      await step(1100, function () { return aClick('[data-nav="d1"]'); }, "D1 · Decision rights — who approves what");
      await step(1500, function () { return aScrollTo('[data-anchor="queue"]', 950); }, "The approval queue, with the assessment behind each decision");
      await step(1600, function () { return aScrollBy(430, 1100); }, "Portfolio by function — including the white space, declared");
      await step(1900, function () { return aScrollEnd(1400); }, "And the matrix itself: decides, consulted, informed");
      await step(1200, function () { return aClick('[data-nav="d6"]'); }, "D6 · Data authorisation — the highest-weight dimension");
      await step(1600, function () { return aScrollTo('[data-anchor="matrix"]', 950); }, "Which AI surface may touch which data class");
      await step(1500, function () { return aScrollBy(300, 1000); }, "PHI rows decided by verified coverage, never by convenience");
      await step(1700, function () { return aScrollEnd(1300); }, "Verification history · the month a mismatch was caught");
      await step(1200, function () { return aClick('[data-nav="d12"]'); }, "D12 · Agent safety — deferred on the record, watchlist live");
      await step(1600, function () { return aScrollTo('[data-anchor="watch"]', 950); }, "Vendor agents already in the tenant, flagged and dated");
      await step(1800, function () { return aScrollEnd(1300); }, "And the named triggers that would activate the dimension");
      await step(1200, function () { return aClick('[data-nav="d2"]'); }, "D2 · Exposure tiering — five tiers, one scored protocol");
      await step(1500, function () { return aScrollTo('[data-anchor="tiers"]', 950); }, "Same inputs, same tier, every time");
      await step(1700, function () { return aScrollEnd(1300); }, "The prohibition tier is empty — and the model proves it");
      await step(1200, function () { return aClick('[data-nav="d8"]'); }, "D8 · Incidents — zero open, clocks ready");
      await step(1500, function () { return aScrollTo('[data-anchor="sev"]', 950); }, "Severity in minutes, with the 60-day clock named");
      await step(1500, function () { return aScrollBy(400, 1000); }, "The register is short · one near-miss, caught pre-delivery");
      await step(1800, function () { return aScrollEnd(1300); }, "Tabletops scheduled against the runbook, not after the event");
      await step(1200, function () { return aClick('[data-nav="d7"]'); }, "D7 · Cost and value — activated ahead of schedule");
      await step(1600, function () { return aScrollTo('[data-anchor="cost"]', 950); }, "Every cost line, including the ones nobody purchased");
      await step(1600, function () { return aScrollBy(430, 1100); }, "Unit economics per run — cost follows autonomy");
      await step(1800, function () { return aScrollEnd(1300); }, "Utilisation is the leading value indicator this early");
      await step(900, function () { return aClick('[data-nav="overview"]'); }, "Back to the overview");
      await step(2600, function () { return aClick('[data-act="board"]'); }, "The board report is generated from the register, not rewritten each quarter");
      await step(700, null);
      if (alive()) atlasPlay();
    } catch (e) { arun = false; }
  }
  function mountAtlas() {
    atWrap = $("[data-atlas]", govWrap || document);
    if (!atWrap || atlasOn) return;
    atlasOn = true;
    atStage = $("[data-astage]", atWrap); atFrame = $("[data-aframe]", atWrap);
    atCursor = $("[data-acursor]", atWrap); atCap = $("[data-acap]", atWrap); atBar = $("[data-abar]", atWrap);
    sizeAtlas();
    if (reduced) return; // no scripted motion; app shows its home screen
    atFrame.addEventListener("load", function () { aready = true; if (avis) atlasPlay(); });
    var d = aDoc();
    if (d && d.readyState === "complete" && d.querySelector("[data-nav]")) aready = true;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { avis = e.isIntersecting; if (e.isIntersecting && aready && !arun) atlasPlay(); });
    }, { threshold: 0.15 }).observe(atWrap);
  }
  function estateClick(btn) {
    if (!govWrap) return;
    var key = btn.getAttribute("data-e");
    var detail = $('[data-estate-detail="' + key + '"]', govWrap);
    var plus = $("[data-eplus]", btn);
    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    if (detail) detail.style.display = open ? "none" : "block";
    if (plus) plus.style.transform = open ? "rotate(0deg)" : "rotate(45deg)";
  }
  function govTab(i) {
    if (!govWrap) return;
    $$("[data-govtab]", govWrap).forEach(function (b) {
      var on = parseInt(b.getAttribute("data-govtab"), 10) === i;
      b.style.color = on ? "#fff" : "rgba(255,255,255,.42)";
      b.style.borderColor = on ? "rgba(255,255,255,.4)" : "rgba(255,255,255,.14)";
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    $$("[data-gpanel]", govWrap).forEach(function (p) {
      p.style.display = parseInt(p.getAttribute("data-gpanel"), 10) === i ? "block" : "none";
    });
    if (i === 0 && !reduced) { sizeAtlas(); if (aready && !arun) atlasPlay(); }
  }
  if (govWrap) {
    $$("[data-govtab]", govWrap).forEach(function (b) {
      b.addEventListener("click", function () { govTab(parseInt(b.getAttribute("data-govtab"), 10) || 0); });
    });
    $$("[data-e]", govWrap).forEach(function (b) {
      b.addEventListener("click", function () { estateClick(b); });
    });
  }

  mountGym();
  mountAtlas();

  /* ============================ resize ================================== */
  var rzT = null;
  window.addEventListener("resize", function () {
    window.clearTimeout(rzT);
    rzT = window.setTimeout(function () { xsCache = null; syncWidth(); apply(false); sizeGym(); sizeAtlas(); }, 120);
  });
})();
